export default {
    'add-pharmaceutical-form': 'Add pharmaceutical form',
    'edit-pharmaceutical-form': 'Edit pharmaceutical form',
    'the-pharmaceutical-form': 'the pharmaceutical form?'
}